import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ImportConfiguration } from '../../../../types/domain-management.types';

@Component({
    selector: 'mon-import-wizard-configure',
    templateUrl: './configure.component.html',
    styleUrls: ['./configure.component.scss'],
    standalone: false,
})
export class ImportWizardConfigureComponent implements OnInit {
    @Input() configuration: ImportConfiguration | null = null;
    @Output() configurationUpdated = new EventEmitter<Partial<ImportConfiguration>>();

    localConfig: ImportConfiguration = {
        skipDomainGroups: false,
        skipPathConstraints: false,
        skipLinkExcludes: false,
    };

    ngOnInit (): void {
        if (this.configuration) {
            this.localConfig = { ...this.configuration };
        }
    }

    /**
     * Update configuration value
     */
    updateConfiguration (key: keyof ImportConfiguration, value: boolean | number): void {
        if (key === 'batchSize' && typeof value === 'number') {
            (this.localConfig as ImportConfiguration & { batchSize?: number })[key] = value;
        } else if ((key === 'retryFailedDomains' || key === 'continueOnError') && typeof value === 'boolean') {
            (this.localConfig as ImportConfiguration & { retryFailedDomains?: boolean; continueOnError?: boolean })[key] = value;
        } else if (typeof value === 'boolean') {
            (this.localConfig as ImportConfiguration)[key as 'skipDomainGroups' | 'skipPathConstraints' | 'skipLinkExcludes'] = value;
        }
        this.configurationUpdated.emit({ [key]: value });
    }

    /**
     * Get description for configuration option
     */
    getOptionDescription (key: keyof ImportConfiguration): string {
        switch (key) {
            case 'skipDomainGroups':
                return 'Skip importing domain group assignments. Domains will be created without group memberships.';
            case 'skipPathConstraints':
                return 'Skip importing path constraints. Domains will be created without URL path restrictions.';
            case 'skipLinkExcludes':
                return 'Skip importing link excludes. Domains will be created without link exclusion rules.';
            default:
                return '';
        }
    }

    /**
     * Get friendly name for configuration option
     */
    getOptionLabel (key: keyof ImportConfiguration): string {
        switch (key) {
            case 'skipDomainGroups':
                return 'Skip Domain Groups';
            case 'skipPathConstraints':
                return 'Skip Path Constraints';
            case 'skipLinkExcludes':
                return 'Skip Link Excludes';
            default:
                return key as string;
        }
    }

    /**
     * Get icon for configuration option
     */
    getOptionIcon (key: keyof ImportConfiguration): string {
        switch (key) {
            case 'skipDomainGroups':
                return 'fas fa-layer-group';
            case 'skipPathConstraints':
                return 'fas fa-route';
            case 'skipLinkExcludes':
                return 'fas fa-ban';
            default:
                return 'fas fa-cog';
        }
    }
}
